import { render, staticRenderFns } from "./shopAuditManage.vue?vue&type=template&id=2b2415b6&scoped=true"
import script from "./shopAuditManage.vue?vue&type=script&lang=js"
export * from "./shopAuditManage.vue?vue&type=script&lang=js"
import style0 from "./shopAuditManage.vue?vue&type=style&index=0&id=2b2415b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2415b6",
  null
  
)

export default component.exports